<div
  class="container"
  fxLayout="row wrap"
  fxLayoutGap="2%"
  fxLayout.lt-md="column"
  matomoForm="incoming-request-export"
>
  <form
    #postForm="ngForm"
    (ngSubmit)="exportCSV(postForm.value)"
    class="csv-form"
  >
    <div
      class="container-fluid"
      fxLayout="row wrap"
      fxLayoutGap="5%"
      fxLayout.lt-md="column"
    >
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.TRANSACTION_ID" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="transactionid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="transactionid"
          matomoClick="request-export-filter-transaction-id"
          (focus)="onFilterUsed('Transaction ID')"
          (blur)="onFilterUsed('Transaction ID', $event.target.value)"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.EXTERNAL_ID" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="externalid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="externalid"
          matomoClick="request-export-filter-external-id"
          (focus)="onFilterUsed('External ID')"
          (blur)="onFilterUsed('External ID', $event.target.value)"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "EXPORT.WORKFLOW_INSTANCE_KEY" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="workflowinstancekey"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="workflowinstancekey"
          matomoClick="request-export-filter-workflow-key"
          (focus)="onFilterUsed('Workflow Instance Key')"
          (blur)="onFilterUsed('Workflow Instance Key', $event.target.value)"
        />
      </mat-form-field>
      <mat-form-field
        (click)="startDatePicker.open(); onDatePickerUsed('start')"
      >
        <mat-label>{{ "TRANSACTIONS.START_DATE" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="startdate"
          placeholder="{{ 'TRANSACTIONS.START_DATE' | translate }}"
          id="startdate"
          [matDatepicker]="startDatePicker"
          matomoClick="request-export-filter-start-date"
          (focus)="onFilterUsed('Start Date')"
          (dateChange)="onFilterUsed('Start Date', $event.value)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startDatePicker"
          matomoClick="request-export-datepicker-start-toggle"
        ></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field (click)="endDatePicker.open(); onDatePickerUsed('end')">
        <mat-label>{{ "TRANSACTIONS.END_DATE" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="enddate"
          placeholder="{{ 'TRANSACTIONS.END_DATE' | translate }}"
          id="enddate"
          [matDatepicker]="endDatePicker"
          matomoClick="request-export-filter-end-date"
          (focus)="onFilterUsed('End Date')"
          (dateChange)="onFilterUsed('End Date', $event.value)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="endDatePicker"
          matomoClick="request-export-datepicker-end-toggle"
        ></mat-datepicker-toggle>
        <mat-datepicker #endDatePicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <mat-label for="querytype" class="form-control">{{
          "EXPORT.FILTER_BY" | translate
        }}</mat-label>
        <select
          id="querytype"
          name="status"
          class="form-control col-sm-4"
          ngModel
          matNativeControl
          matomoClick="request-export-filter-status"
          (focus)="onFilterUsed('Status')"
          (change)="onFilterUsed('Status', $event.target.value)"
        >
          <option value="" matomoClick="request-export-status-option-all">
            {{ "TRANSACTIONS.STATUS" | translate }}
          </option>
          <option
            value="ACCEPTED"
            matomoClick="request-export-status-option-accepted"
          >
            {{ "EXPORT.STATUS_ACCEPTED" | translate }}
          </option>
          <option
            value="NOT_AUTOSAVED"
            matomoClick="request-export-status-option-not-autosaved"
          >
            {{ "EXPORT.STATUS_NOT_AUTOSAVED" | translate }}
          </option>
          <option
            value="FAILED"
            matomoClick="request-export-status-option-failed"
          >
            {{ "EXPORT.STATUS_FAILED" | translate }}
          </option>
          <option
            value="IN_PROGRESS"
            matomoClick="request-export-status-option-in-progress"
          >
            {{ "EXPORT.STATUS_PENDING_INCOMPLETE" | translate }}
          </option>
        </select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "EXPORT.ERROR_DESCRIPTION" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="errordescription"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="errordescription"
          matomoClick="request-export-filter-error-description"
          (focus)="onFilterUsed('Error Description')"
          (blur)="onFilterUsed('Error Description', $event.target.value)"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.PAYER_ID" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="payerid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="payerid"
          matomoClick="request-export-filter-payer-id"
          (focus)="onFilterUsed('Payer ID')"
          (blur)="onFilterUsed('Payer ID', $event.target.value)"
        />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "TRANSACTIONS.PAYEE_ID" | translate }}</mat-label>
        <input
          matInput
          type="textArea"
          class="form-control col-sm-4"
          ngModel
          name="payeeid"
          placeholder="{{ 'EXPORT.COMMA_SEPARATED_LIST' | translate }}"
          id="payeeid"
          matomoClick="request-export-filter-payee-id"
          (focus)="onFilterUsed('Payee ID')"
          (blur)="onFilterUsed('Payee ID', $event.target.value)"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{
          "TRANSACTIONS.AMS_BUSINESS_SHORT_CODE" | translate
        }}</mat-label>
        <mat-select
          class="form-control col-sm-4"
          ngModel
          name="payerdfspid"
          placeholder="comma-separated-list"
          id="payerdfspid"
          multiple
          matomoClick="request-export-filter-ams-business-code"
          (focus)="onFilterUsed('AMS Business Code')"
          (selectionChange)="
            onFilterUsed('AMS Business Code', $event.value);
            onAmsCodeSelection($event.value)
          "
        >
          <mat-option
            *ngFor="let code of amsCodes"
            [value]="code.value"
            matomoClick="request-export-ams-code-option-{{ code.value }}"
          >
            {{ code.option }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <button
      mat-stroked-button
      type="submit"
      [disabled]="!postForm.valid"
      matomoClick="request-export-csv-button"
      (click)="onFormValidationChange(postForm.valid)"
    >
      {{ "EXPORT.EXPORT_CSV" | translate }}
    </button>
  </form>
</div>
